export function readBooleanPreference(key, fallback = false) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined || raw === '') return fallback;
    if (raw === 'true' || raw === '1') return true;
    if (raw === 'false' || raw === '0') return false;
    const parsed = JSON.parse(raw);
    if (typeof parsed === 'boolean') return parsed;
    return fallback;
  } catch {
    return fallback;
  }
}

export function writeBooleanPreference(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(!!value));
  } catch {
    /* ignore quota / private mode */
  }
}
